import React, { useState } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  TextField,
  Button,
  InputLabel,
  CircularProgress,
  Modal,

} from "@mui/material";
import { BiErrorCircle } from "react-icons/bi";
import { FaRegCircleCheck } from "react-icons/fa6";
import { useUserAdmin } from "../../../admin/UserContext";
import { IoClose } from "react-icons/io5";

export const CrearSliderPortadaInicio = ({onclose, fetchSliders}) => {
    const { Token} = useUserAdmin();
    const [loading, setLoading] = useState(false);
    const backendURL = process.env.REACT_APP_BACKEND_URL;
    const [successAlertOpen, setSuccessAlertOpen] = useState(false);
    const [errorAlertOpen, setErrorAlertOpen] = useState(false);
    const [enviandoAlert, setEnviandoAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
  const [formData, setFormData] = useState({
    fondo: null,
    logo: null,
    texto: null,
    maquina: null,
    
    posicion: ""
  });

  const handleFileChange = (e, field) => {
    const file = e.target.files[0];
    setFormData({ ...formData, [field]: file });
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, posicion: e.target.value });
  };

 const handleSubmit = async (e) => {
    e.preventDefault();
    setEnviandoAlert(true)
    const data = new FormData();
    data.append("imagen_fondo", formData.fondo);
    data.append("imagen_logo", formData.logo);  
    data.append("imagen_texto", formData.texto);
    data.append("imagen_maquina", formData.maquina);
    data.append("posicion", formData.posicion);


    try {
      setLoading(true);
      await axios.post(`${backendURL}/api/bannerStore`, data, {
        headers: {
          Authorization: `Bearer ${Token}`,
          "Content-Type": "multipart/form-data"
        }
      });

      setAlertMessage("Se ha generado con éxito el slider.");
      setEnviandoAlert(false)
      setSuccessAlertOpen(true);
      
    
    } catch (error) {
      console.error(error);
      setAlertMessage("Error al crear slider.");
      setErrorAlertOpen(true);
       setEnviandoAlert(false)
    } finally {
      setLoading(false);
      await fetchSliders()
      setTimeout(() => {
        setSuccessAlertOpen(false);
         setEnviandoAlert(false)
        setErrorAlertOpen(false);
        onclose();
       
      }, 3000);
    }
  };

  const renderPreview = (file) => {
    return file ? (
      <img
        src={URL.createObjectURL(file)}
        alt="preview"
        style={{
          width: "100%",
          maxWidth: "250px",
          height: "auto",
          marginBottom: "10px",
          borderRadius: "8px",
          border: "2px solid #585857"
        }}
      />
    ) : null;
  };

  return (
    <Box p={3}>
      <Typography variant="h5" gutterBottom>
        Crear Nuevo Slider
      </Typography>

      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '25px' }}>
        <div>
          <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Imagen de fondo</InputLabel>
          {renderPreview(formData.fondo)}
          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleFileChange(e, "fondo")}
            style={{ border: "2px solid #585857", padding: "8px", borderRadius: "6px", width: "100%" }}
          />
        </div>

        <div>
          <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Imagen de logo</InputLabel>
          {renderPreview(formData.logo)}
          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleFileChange(e, "logo")}
            style={{ border: "2px solid #585857", padding: "8px", borderRadius: "6px", width: "100%" }}
          />
        </div>

        <div>
          <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Imagen de texto</InputLabel>
          {renderPreview(formData.texto)}
          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleFileChange(e, "texto")}
            style={{ border: "2px solid #585857", padding: "8px", borderRadius: "6px", width: "100%" }}
          />
        </div>

        <div>
          <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Imagen de máquina</InputLabel>
          {renderPreview(formData.maquina)}
          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleFileChange(e, "maquina")}
            style={{ border: "2px solid #585857", padding: "8px", borderRadius: "6px", width: "100%" }}
          />
        </div>
        

        <TextField
          label="Posición"
          type="number"
          value={formData.posicion}
          onChange={handleInputChange}
          inputProps={{ min: 1 }}
          sx={{
            '& .MuiInputBase-input': {
                color: '#585857', // Color del número (input)
                },
                '& .MuiInputLabel-root': {
                color: '#585857', // Color del label
                },
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                color:'#585857',
                borderColor: '#585857'
              },
              '&:hover fieldset': {
                borderColor: '#585857'
              },
              '&.Mui-focused fieldset': {
                borderColor: '#585857'
              }
            }
          }}
        />

        <Button
          variant="contained"
          disabled={loading}
          sx={{
            backgroundColor: "#5E487B",
            color: "#fff",
            textTransform: "capitalize"
          }}
          type="submit"
        >    {loading ? <CircularProgress size={24} /> : 'Guardar Slider'}
          
        </Button>
      </form>

       <Modal open={successAlertOpen} onClose={() => setSuccessAlertOpen(false)}>
                <Box sx={modalStyle}>
                    <section className="closemodal" onClick={() => setSuccessAlertOpen(false)}>
                        <IoClose style={{color:'#585857'}}/>
                    </section>
                    <section style={{ textAlign: 'center' }}>
                        <FaRegCircleCheck style={{ color: 'green', fontSize: '2rem', marginBottom: '1rem' }} />
                        <p>{alertMessage}</p>
                    </section>
                </Box>
            </Modal>

            {/* Modal de error */}
            <Modal open={errorAlertOpen} onClose={() => setErrorAlertOpen(false)}>
                <Box sx={modalStyle}>
                    <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
                        <IoClose />
                    </section>
                    <section style={{ textAlign: 'center' }}>
                        <BiErrorCircle style={{ color: 'red', fontSize: '2rem', marginBottom: '1rem' }} />
                        <p>{alertMessage}</p>
                    </section>
                </Box>
            </Modal>

            {/* Modal de progreso */}
            <Modal open={enviandoAlert} onClose={() => setEnviandoAlert(false)}>
                <Box sx={modalStyle}>
                <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
                        <IoClose />
                    </section>
                    <section style={{ textAlign: 'center', padding: '1rem' }}>
                        <CircularProgress style={{ color: '#694B81' }} />
                        <p>Procesando solicitud...</p>
                    </section>
                </Box>
            </Modal>
    </Box>
  );
};

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: '#ffff',
    border: '0px solid #000',
    boxShadow: 24,
    p: 4,
    borderRadius:'10px'
  };
